<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    :title="title"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="模板名称：" prop="templateName">
          <el-input size="mini" v-model.trim="form.templateName" placeholder="请输入模板名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="电梯类型：" class="mr0" prop="liftTypeObj">
          <el-select
            size="mini"
            v-model="form.liftTypeObj"
            placeholder="请选择电梯类型"
            clearable
            filterable
            @change="selectLift"
            value-key="dictionaryCode"
          >
            <el-option
              v-for="item in dtlxDicts"
              :key="item.dictionaryCode"
              :label="item.dictionaryValue"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注信息：" class="mr0">
          <el-input size="mini" v-model.trim="form.remark" placeholder="请输入备注信息" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
      >确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { savePointTemplate, copyPointTemplate } from "@/api/FaultTypesTemplate";
import { mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        liftTypeCode: "",
        liftTypeName: "",
        remark: "",
        templateName: "",
        liftTypeObj: null,
      },
      rules: {
        templateName: [
          {
            required: true,
            message: "请输入模板名称",
            trigger: "blur",
          },
        ],
        liftTypeObj: [
          {
            required: true,
            message: "请输入选择电梯类型",
            trigger: "change",
          },
        ],
      },
      loadBtn: false,
      title: '编辑模板'
    };
  },
  props: {
    editData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState("common/dictionary", ["dtlxDicts"]),
  },
  created() {},
  mounted() {
    this.form = { ...this.editData };
    if (this.form.copy) {
      this.title = "复制模板"
    }
    const obj = {
      dictionaryCode: this.form.liftTypeCode,
      dictionaryValue: this.form.liftTypeName,
    };
    this.$set(this.form, "liftTypeObj", obj);
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          let res;
          let message = "编辑成功"
          if (!this.form.copy) {
            res = await savePointTemplate(this.form);
          } else {
            message = "复制成功"
            delete this.form.createTime
            delete this.form.updateTime
            delete this.form.createUser
            delete this.form.updateUser
            res = await copyPointTemplate(this.form);
          }
          if (res.code === 200) {
            this.$message.success(message);
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
    selectLift(val) {
      if (val) {
        this.form.liftTypeName = val.dictionaryValue;
        this.form.liftTypeCode = val.dictionaryCode;
      } else {
        this.form.liftTypeName = "";
        this.form.liftTypeCode = "";
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/FaultTypesTemplate/components/EditTemplate.vue